import React, {PropsWithChildren} from "react";
import styled from "@emotion/styled";

import {display, m} from "@pg-design/helpers-css-strings";

type IProps = PropsWithChildren<{
    iconSize: string;
    showOnMobile?: boolean;
}>;

export const RowHeaderIconWrap = (props: IProps) => {
    return (
        <HeaderIconWrapper iconSize={props.iconSize} showOnMobile={props.showOnMobile}>
            {props.children}
        </HeaderIconWrapper>
    );
};

const HeaderIconWrapper = styled.div<{showOnMobile?: boolean; iconSize: string}>`
    align-items: center;
    justify-content: center;
    width: ${({iconSize}) => iconSize}rem;
    height: ${({iconSize}) => iconSize}rem;
    ${m(0, 1, 0, 0)}

    ${({showOnMobile}) => !showOnMobile && display("none")};

    @media (min-width: ${({theme}) => theme.breakpoints.md}) {
        display: flex;
    }

    svg {
        fill: ${({theme}) => theme.colors.gray["700"]};
    }
`;
import React, {PropsWithChildren} from "react";
import styled from "@emotion/styled";

import {display, m} from "@pg-design/helpers-css-strings";

type IProps = PropsWithChildren<{
    iconSize: string;
    showOnMobile?: boolean;
}>;

export const RowHeaderIconWrap = (props: IProps) => {
    return (
        <HeaderIconWrapper iconSize={props.iconSize} showOnMobile={props.showOnMobile}>
            {props.children}
        </HeaderIconWrapper>
    );
};

const HeaderIconWrapper = styled.div<{showOnMobile?: boolean; iconSize: string}>`
    align-items: center;
    justify-content: center;
    width: ${({iconSize}) => iconSize}rem;
    height: ${({iconSize}) => iconSize}rem;
    ${m(0, 1, 0, 0)}

    ${({showOnMobile}) => !showOnMobile && display("none")};

    @media (min-width: ${({theme}) => theme.breakpoints.md}) {
        display: flex;
    }

    svg {
        fill: ${({theme}) => theme.colors.gray["700"]};
    }
`;
